/*eslint-disable*/
import React, {useEffect, useState} from 'react'
import { Formik, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Container, Button, Label, Modal, } from 'semantic-ui-react';
import Axios from 'axios';

import { MyInput, MyTextArea } from '../../formikInput/input';
import APP_CONSTANTS from '../../../config/constants';

import { DateData } from '../../formikInput/date';
import UploadFile from '../../formikInput/fileUpload';
import cogoToast from 'cogo-toast';

import VehicleTypeDropdown from '../../dropdowns/vehicleTypeDropdown';
import VehicleOwnershipTypeDropdown from '../../dropdowns/vehicleOwnershipTypeDropdown';
import TrackingTypeDropdown from '../../dropdowns/trackingTypeDropdown';
import { LOCAL_STORAGE, DATE_FORMATS } from '../../../config/const';
import {vendor_vehicle} from './vendorConstants'

const AddVendorVehicleModal = ({ handleCloseUserAddModal, user, vendorId, ...props }) => {

    const [vehicleTypeId, setVehicleTypeId] = useState("") 
    
    const initialValues = {
        vehicleNo: '',
        vehicleType: '',
        vehicleOwnershipType: '',
        vehicleLoadCapacity: '',
        trackingTypeId:'',
        gpsPartner: '',
        baseLocation: '',
        vehicleDimension: '',
        pucDate: '',
        pucFile: '',
        insuranceDate: '',
        insuranceFile: '',
        fitnessCertificateDate: '',
        fitnessCertificateFile: '',
        permitDate: '',
        permitFile: '',
        vehicleRCNo: '',
        vehicleRCDate: '',
        roadTaxValidityDate: '',
    };

    const validateSchema = yup.object().shape({
        vehicleNo: yup.string().required('Required'),
        vehicleType : yup.string().required('Required'),
        vehicleOwnershipType: yup.string().required('Required'),
    });

    const onSubmit = (values, onSubmitProps) => {

        const userData = {
            customerNo: LOCAL_STORAGE.customerNo,
            customerNumber: LOCAL_STORAGE.customerNo,
            customer_no: LOCAL_STORAGE.customerNo,
            userId: LOCAL_STORAGE.userId,
            user_id: LOCAL_STORAGE.userId,
            transporterId: vendorId,
            vehicleBaseLocation: values.baseLocation,
            vehicleCapacity: values.vehicleLoadCapacity,
            vehicleDimensions: values.vehicleDimension,
            vehicleFitnessCertExpiryDate: values.fitnessCertificateDate,
            vehicleFitnessCertFile: values.fitnessCertificateFile ? values.fitnessCertificateFile.base64.split(',')[1] : '',
            vehicleGps: values.gpsPartner,
            vehicleInsuranceExpiryDate: values.insuranceDate,
            vehicleInsuranceFile: values.insuranceFile ? values.insuranceFile.base64.split(',')[1] : '',
            vehicleNumber: values.vehicleNo,
            vehicleOwner: values.vehicleOwnershipType,
            vehiclePUCExpiryDate: values.pucDate,
            vehiclePUCFile: values.pucFile ? values.pucFile.base64.split(',')[1] : '',
            vehiclePermitExpiryDate: values.permitDate,
            vehiclePermitFile: values.permitFile ? values.permitFile.base64.split(',')[1] : '',
            vehicleRCNo: values.vehicleRCNo,
            vehicleRCNoExpiryDate: values.vehicleRCDate,
            vehicleRoadTaxValidityDate: values.roadTaxValidityDate,
            vehicleType: values.vehicleType,
            vehicleTypeId: vehicleTypeId,
            trackingTypeId : values.trackingTypeId
        }

        console.log("Update Data", userData);
        
        Axios.put(`${APP_CONSTANTS.BASE_URL}masters/vehicleMaster/`, userData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('apiToken')
            }
        }).then((response => {
             if(response.data?.status===200){
                cogoToast.success(response.data.message, { position: 'top-right'})
                setTimeout(() => {window.location.reload()} , 1000) 
             }else{
                 cogoToast.error(response.data.message, { position: 'top-right'})   
                 onSubmitProps.setSubmitting(false); 
             }
        }))
            .catch(error => {
                console.log(error)
                onSubmitProps.setSubmitting(false);
            })        

    };

    return (
        <>
            <Formik 
                initialValues={initialValues}
                validationSchema={validateSchema}
                onSubmit={onSubmit}
            >
                {({ values, isSubmitting, errors, touched, handleSubmit,setFieldValue }) =>{
                    useEffect(()=>{
                        setCustomerPreferredTrackingType()
                    },[])
                    const setCustomerPreferredTrackingType = async()=>{
                    await Axios.get(`${process.env.REACT_APP_BASE_URL}/masters/customerSettings?customerNumber=${LOCAL_STORAGE.customerNo}&userId=${LOCAL_STORAGE.userId}`, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } }).then((resp)=>{
                        if(resp.data.status===200){
                           resp?.data?.resultSet?.preferredTrackingType? setFieldValue("trackingTypeId",resp.data.resultSet.preferredTrackingType) : setFieldValue("trackingTypeId",1)
                        }else{
                            setFieldValue("trackingTypeId",1)
                        }
                    })
                }
                return (
                    <>
                        
                        <Modal.Content>
                            <Container>
                            {console.log("Values", user)}
                                <div className="ui form">
                                    <FormUi.Group>
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.vehicle_no?.title||"Vehicle No."}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={5}>
                                            <Fieldmik name="vehicleNo" component={MyInput} error={values.vehicleNo ? false : true} placeholder={vendor_vehicle?.fields?.vehicle_no?.placeholder||"Enter Vehicle Number"} />
                                            {touched.vehicleNo && errors.vehicleNo ? <Label size="mini" prompt pointing>{errors.vehicleNo}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width={2} />
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.vehicle_type?.title||"Vehicle Type"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={5}>
                                            <Fieldmik name="vehicleType" component={VehicleTypeDropdown} setVehicleTypeId={setVehicleTypeId} placeholder={vendor_vehicle?.fields?.vehicle_type?.placeholder||"Select Vehicle Type"} />
                                            {touched.vehicleType && errors.vehicleType ? <Label size="mini" prompt pointing>{errors.vehicleType}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.ownership_type?.title||"Vehicle Ownership Type"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={5}>
                                            <Fieldmik name="vehicleOwnershipType" component={VehicleOwnershipTypeDropdown} error={values.vehicleOwnershipType ? false : true} placeholder={vendor_vehicle?.fields?.ownership_type?.placeholder||"Select Ownership Type"} />
                                            {touched.vehicleOwnershipType && errors.vehicleOwnershipType ? <Label size="mini" prompt pointing>{errors.vehicleOwnershipType}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width={2} />
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.tracking_type?.title||"Tracking Type"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={5}>
                                            <Fieldmik name="trackingTypeId" component={TrackingTypeDropdown} error={values.trackingTypeId ? false : true} placeholder={vendor_vehicle?.fields?.tracking_type?.placeholder||"Select Tracking Type"} value={values.trackingTypeId}/>
                                            {touched.trackingTypeId && errors.trackingTypeId ? <Label size="mini" prompt pointing>{errors.trackingTypeId}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.gps_partner?.title||"GPS Partner"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={5}>
                                            <Fieldmik name="gpsPartner" component={MyInput} error={values.gpsPartner ? false : true} placeholder={vendor_vehicle?.fields?.gps_partner?.placeholder} />
                                            {touched.gpsPartner && errors.gpsPartner ? <Label size="mini" prompt pointing>{errors.gpsPartner}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width={2} />
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.base_location?.title||"Base Location"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={5}>
                                            <Fieldmik name="baseLocation" component={MyInput} error={values.baseLocation ? false : true} placeholder={vendor_vehicle?.fields?.base_location?.placeholder||"Enter Base Location"} />
                                            {touched.baseLocation && errors.baseLocation ? <Label size="mini" prompt pointing>{errors.baseLocation}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.vehicle_dimension?.title||"Vehicle Dimension"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={5}>
                                            <Fieldmik name="vehicleDimension" component={MyInput} error={values.vehicleDimension ? false : true} placeholder={vendor_vehicle?.fields?.vehicle_dimension?.placeholder||"L*B*H"} />
                                            {touched.vehicleDimension && errors.vehicleDimension ? <Label size="mini" prompt pointing>{errors.vehicleDimension}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width={2} />
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.load_capacity?.title||"Vehicle Load Capacity"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={5}>
                                            <Fieldmik name="vehicleLoadCapacity" component={MyInput} error={values.vehicleLoadCapacity ? false : true} placeholder={vendor_vehicle?.fields?.load_capacity?.placeholder||"Enter Load Capacity"} />
                                            {touched.vehicleLoadCapacity && errors.vehicleLoadCapacity ? <Label size="mini" prompt pointing>{errors.vehicleLoadCapacity}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.puc?.title||"PUC"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                            <DateData
                                                name={`pucDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat={DATE_FORMATS.dd_MM_yyyy||"dd-MM-yyyy"}
                                                placeholderText="Date"
                                                selected={values.pucDate}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input error={values.pucDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.pucDate && errors.pucDate ? <Label size="mini" prompt pointing>{errors.pucDate}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width={1}>
                                            <Fieldmik name={`pucFile`} component={UploadFile} typer={[".pdf"]} size="small" buttonName="PDF" clrd={values.pucFile ? "green" : ""} />
                                        </FormUi.Field>
                                        <FormUi.Field width={3} />
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.insurance?.title||"Insurance"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                            <DateData
                                                name={`insuranceDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat={DATE_FORMATS.dd_MM_yyyy||"dd-MM-yyyy"}
                                                placeholderText="Date"
                                                selected={values.insuranceDate}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input error={values.insuranceDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.insuranceDate && errors.insuranceDate ? <Label size="mini" prompt pointing>{errors.insuranceDate}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width={1}>
                                            <Fieldmik name={`insuranceFile`} component={UploadFile} size="small" buttonName="PDF" typer={[".pdf"]} clrd={values.insuranceFile ? "green" : ""}/>
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.fitness?.title||"Fitness Certificate"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                            <DateData
                                                name={`fitnessCertificateDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat={DATE_FORMATS.dd_MM_yyyy||"dd-MM-yyyy"}
                                                placeholderText="Date"
                                                selected={values.fitnessCertificateDate}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input error={values.fitnessCertificateDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.fitnessCertificateDate && errors.fitnessCertificateDate ? <Label size="mini" prompt pointing>{errors.fitnessCertificateDate}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width={1}>
                                            <Fieldmik name={`fitnessCertificateFile`} component={UploadFile} size="small" buttonName="PDF" typer={[".pdf"]} clrd={values.fitnessCertificateFile ? "green" : ""}/>
                                        </FormUi.Field>
                                        <FormUi.Field width={3} />
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.permit?.title||"Permit"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                            <DateData
                                                name={`permitDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat={DATE_FORMATS.dd_MM_yyyy||"dd-MM-yyyy"}
                                                placeholderText="Date"
                                                selected={values.permitDate}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input error={values.permitDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.permitDate && errors.permitDate ? <Label size="mini" prompt pointing>{errors.permitDate}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width={1}>
                                            <Fieldmik name={`permitFile`} component={UploadFile} typer={[".pdf"]} size="small" buttonName="PDF" clrd={values.permitFile ? "green" : ""}/>
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.rc_number?.title||"Vehicle RC Number"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                            <Fieldmik name="vehicleRCNo" component={MyInput} error={values.vehicleRCNo ? false : true} />
                                            {touched.vehicleRCNo && errors.vehicleRCNo ? <Label size="mini" prompt pointing>{errors.vehicleRCNo}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                            <DateData
                                                name={`vehicleRCDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat={DATE_FORMATS.dd_MM_yyyy||"dd-MM-yyyy"}
                                                placeholderText="Date"
                                                selected={values.vehicleRCDate}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input error={values.vehicleRCDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.vehicleRCDate && errors.vehicleRCDate ? <Label size="mini" prompt pointing>{errors.vehicleRCDate}</Label> : ''}
                                        </FormUi.Field>
                                        {/* <FormUi.Field width={1} /> */}
                                        
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width={2}>
                                            <label className="labelName mt-2">{vendor_vehicle?.fields?.road_tax?.title||"Road Tax Validity"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width={3}>
                                            <DateData
                                                name={`roadTaxValidityDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat={DATE_FORMATS.dd_MM_yyyy||"dd-MM-yyyy"}
                                                placeholderText="Date"
                                                selected={values.roadTaxValidityDate}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input error={values.roadTaxValidityDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.roadTaxValidityDate && errors.roadTaxValidityDate ? <Label size="mini" prompt pointing>{errors.roadTaxValidityDate}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                           
                                </div>
                            </Container>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button onClick={handleCloseUserAddModal} size="mini">{vendor_vehicle?.buttons?.cancel||"Cancel"}</Button>
                            <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} size="mini" primary>{vendor_vehicle?.buttons?.submit||"Submit"}</Button>
                        </Modal.Actions>
                    </>
                )}}
            </Formik>
        </>
    )
}


export default AddVendorVehicleModal
